<template>
  <div class="s-featured-slick">
    <div class="page-container">
      <div v-if="percentage" class="s-featured-slick__progress-bar">
        <ProgressBar :percentage="percentage" />
      </div>

      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="s-featured-slick__slick"
        :options="slickOptions"
        @init="onInit"
        @beforechange="onBeforeChange">
        <div
          v-for="(item, index) in records"
          :key="index"
          class="s-featured-slick__slide item">
          <VehicleFlexDrive :item="item" />
        </div>
      </SlickCarousel>
      <span
        v-if="records.length"
        class="s-featured-slick__disclaimer"
        :class="{ 'no-progress-bar': !percentage }">
        Οι φωτογραφίες των οχημάτων είναι ενδεικτικές.
      </span>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import ProgressBar from './../components/common/ProgressBar.vue'
import SlickCarousel from '../components/common/SlickCarousel.vue'
import { v4 as uuidv4 } from 'uuid'
import VehicleFlexDrive from './../components/VehicleFlexDriveV2.vue'

export default {
  components: { ProgressBar, SlickCarousel, VehicleFlexDrive },

  data() {
    return {
      percentage: 0,
      records: [],
      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
        responsive: [
          {
            breakpoint: 1390,
            settings: { slidesToShow: 3, variableWidth: false },
          },
          {
            breakpoint: 1070,
            settings: { slidesToShow: 2, variableWidth: false },
          },
          {
            breakpoint: 992,
            settings: { slidesToShow: 1, variableWidth: false },
          },
        ],
      },
    }
  },
  mounted() {
    const { records } = lib.getData('featuredData')
    this.records = records

    if (this.configuration.variableWidth) {
      this.slickOptions.slidesToShow = 1
      this.slickOptions.variableWidth = true
      this.slickKey = uuidv4()
    }
  },
  methods: {
    onInit(event, slick) {
      this.percentage = lib.getSlickProgressBarPercentage(slick)
    },
    onBeforeChange(event, slick) {
      setTimeout(() => {
        this.percentage = lib.getSlickProgressBarPercentage(slick)
      }, 100)
    },
  },
}
</script>
